export type PromotionIntegrationType = 'GameSession' | 'SingleSet' | 'MultiSets' | 'MultiSetsMulticampaign' | 'Null' | 'Default';